/* global window */
import angular from 'angular';
import { TweenMax } from 'gsap';
import ngAnimate from 'angular-animate';

function fadeAndGrowAnimation() {
  return {
    beforeAddClass: (element, className, done) => {
      if (className === 'ng-hide') {
        const el = element[0];
        const originalStyles = el.style.cssText;
        el.style.overflow = 'hidden';
        el.style.height = el.scrollHeight;
        const transitionSpeed = el.scrollHeight < 500
          ? 0.3
          : el.scrollHeight < 1500
            ? 0.6
            : el.scrollHeight < 2500
              ? 1
              : 1.5;

        TweenMax.to(
          el,
          transitionSpeed,
          {
            height: 0,
            borderTopWidth: 0,
            borderBottomWidth: 0,
            opacity: 0,
            paddingTop: 0,
            paddingBottom: 0,
            marginTop: 0,
            marginBottom: 0,
            onComplete: () => {
              el.style.cssText = originalStyles;
              el.removeAttribute('style');
              done();
            },
          },
        );
      }
    },
    removeClass: (element, className, done) => {
      if (className === 'ng-hide') {
        const el = element[0];
        const originalStyles = el.style.cssText;
        const originalBorderWidth = window.getComputedStyle(el, null).getPropertyValue('border-width');
        const originalPadding = window.getComputedStyle(el, null).getPropertyValue('padding');
        const originalMargin = window.getComputedStyle(el, null).getPropertyValue('margin');
        const transitionSpeed = el.scrollHeight < 500
          ? 0.3
          : el.scrollHeight < 1500
            ? 0.6
            : el.scrollHeight < 2500
              ? 1
              : 1.5;


        el.style.overflow = 'hidden';
        el.style.height = 0;
        el.style.borderTopWidth = 0;
        el.style.borderBottomWidth = 0;
        el.style.paddingTop = 0;
        el.style.paddingBottom = 0;
        el.style.marginTop = 0;
        el.style.marginBottom = 0;
        el.style.opacity = 0;

        TweenMax.to(
          el,
          transitionSpeed,
          {
            height: el.scrollHeight,
            borderWidth: originalBorderWidth,
            padding: originalPadding,
            margin: originalMargin,
            opacity: 1,
            onComplete: () => {
              el.style.cssText = originalStyles;
              el.removeAttribute('style');
              done();
            },
          }
        );
      }
    }
  };
}


fadeAndGrowAnimation.$inject = [];

export default angular.module('app.animations', [ngAnimate])
  .animation('.fade-and-grow', fadeAndGrowAnimation)
  .name;
